export const dashUrl = '/dash/';
export const dashSeoPerformaceUrl = `${dashUrl}seo-performance/`;
export const dashPrepareSupersetFunnelViewsUrl = `${dashUrl}prepare-superset-funnel/`;
